var passiveSupported = false

try {
  var options = Object.defineProperty({}, 'passive', {
    get: function () {
      passiveSupported = true
    }
  })
  window.addEventListener('test', null, options)
} catch (err) {}

module.exports = passiveSupported


// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/libs/passive_supported.js